import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { jsmWorkItemEmbedRoute } from '@jira/router-routes__servicedesk-jsm-work-item-routes/src/jsmWorkItemEmbedRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { jsmWorkItemPageEntrypoint } from './ui/jsmWorkItemPageEntrypoint.tsx';

export const jsmWorkItemEmbedRouteEntry: Route = createEntry(jsmWorkItemEmbedRoute, () => ({
	group: 'servicedesk',
	layout: chromelessLayout,
	resources: [],
	entryPoint: () =>
		fg('jsm_aniv_routing_phase_1') ? jsmWorkItemPageEntrypoint : notFoundPageEntrypoint,
	bifrost: {
		bifrostGroup: 'shell-only',
		redirects: [
			{
				key: 'jsm-work-item-route-redirect',
				timeoutMs: 10,
				handler: async ({ match, url }) => {
					const issueKey = match.params.issueKey;

					// eslint-disable-next-line jira/ff/no-preconditioning
					if (issueKey && !(fg('jsm_aniv_routing_phase_1') && fg('jsm_aniv_route_redirection'))) {
						return `/browse/${issueKey}/embed${url.search}`;
					}
				},
			},
		],
	},
}));
